export default __webpack_public_path__ + "static/media/triangle-2x.b3fda72b.svg";